import { SimpleTabs } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  replaceIframeWithWarning,
  isCookiesEnable
} from '../../pages/help-center/marketingSupport';
import { useEffect } from 'react';
import VideoWarning from '../VideoWarning/VideoWarning';
import PurifiedHtml from '@app/components/common/PurifiedHtml';
import styles from './LongDescription.module.scss';

const LongDescription = ({ longDescriptionContent = [] }) => {
  const firstItem = (longDescriptionContent || [])[0] || {};

  useEffect(() => {
    longDescriptionContent &&
      longDescriptionContent.length &&
      replaceIframeWithWarning();
    isCookiesEnable();

    window.addEventListener('OneTrustGroupsUpdated', () => {
      isCookiesEnable();
    });
  }, [longDescriptionContent]);

  return Array.isArray(longDescriptionContent) ? (
    <section
      className={cx(
        styles.product_list_long_description,
        styles.product_tab_titles,
        'u-color--ExtraDarkGray text-md'
      )}
      data-testid="long description"
    >
      {longDescriptionContent.length > 1 ? (
        <SimpleTabs
          defaultActive={firstItem.label}
          schema={longDescriptionContent.map(item => ({
            content: <PurifiedHtml htmlString={item.value} />,
            id: item.label,
            title: item.label
          }))}
        />
      ) : (
        <PurifiedHtml htmlString={firstItem.value} />
      )}
      <div
        id="video-cookie-warning"
        data-testid="warning-message"
        className={cx(
          'video-cookie-warning float-end position-relative d-none',
          styles.warning_message
        )}
      >
        <VideoWarning />
      </div>
    </section>
  ) : null;
};

LongDescription.propTypes = {
  longDescriptionContent: PropTypes.arrayOf(
    PropTypes.shape({
      label: 'string',
      value: 'string'
    })
  )
};

export default LongDescription;
